export const DEFAULT_CURRENCY_CODE = 'USD';
export const DEFAULT_MINOR_UNIT = 2;
export const DEFAULT_COUNTRY_CODE = 'US';
export const DEFAULT_LOCALE = 'en';
export const DEFAULT_LOCALE_WITH_REGION = 'en-US';
export const DEFAULT_NAMESPACE = 'translation';

// last updated 1 April 2022 => https://en.wikipedia.org/wiki/ISO_4217 && https://www.iban.com/currency-codes
export const CURRENCIES_BY_ALPHABETIC_CODE = {
  AED: { numericCode: '784', minorUnit: 2, currencyName: 'United Arab Emirates Dirham' },
  AFN: { numericCode: '971', minorUnit: 2, currencyName: 'Afghan Afghani' },
  ALL: { numericCode: '008', minorUnit: 2, currencyName: 'Albanian Lek' },
  AMD: { numericCode: '051', minorUnit: 2, currencyName: 'Armenian Dram' },
  ANG: {
    numericCode: '532',
    minorUnit: 2,
    currencyName: 'Netherlands Antillean Guilder',
  },
  AOA: { numericCode: '973', minorUnit: 2, currencyName: 'Angolan Kwanza' },
  ARS: { numericCode: '032', minorUnit: 2, currencyName: 'Argentine Peso' },
  AUD: { numericCode: '036', minorUnit: 2, currencyName: 'Australian Dollar' },
  AWG: { numericCode: '533', minorUnit: 2, currencyName: 'Aruban Florin' },
  AZN: { numericCode: '944', minorUnit: 2, currencyName: 'Azerbaijani Manat' },
  BAM: { numericCode: '977', minorUnit: 2, currencyName: 'Bosnia and Herzegovina Convertible Mark' },
  BBD: { numericCode: '052', minorUnit: 2, currencyName: 'Barbados Dollar' },
  BDT: { numericCode: '050', minorUnit: 2, currencyName: 'Bangladeshi Taka' },
  BGN: { numericCode: '975', minorUnit: 2, currencyName: 'Bulgarian Lev' },
  BHD: { numericCode: '048', minorUnit: 3, currencyName: 'Bahraini Dinar' },
  BIF: { numericCode: '108', minorUnit: 0, currencyName: 'Burundi Franc' },
  BMD: { numericCode: '060', minorUnit: 2, currencyName: 'Bermudian Dollar' },
  BND: { numericCode: '096', minorUnit: 2, currencyName: 'Brunei Dollar' },
  BOB: { numericCode: '068', minorUnit: 2, currencyName: 'Boliviano' },
  BRL: { numericCode: '986', minorUnit: 2, currencyName: 'Brazilian Real' },
  BSD: { numericCode: '044', minorUnit: 2, currencyName: 'Bahamian Dollar' },
  BTN: { numericCode: '064', minorUnit: 2, currencyName: 'Bhutanese Ngultrum' },
  BWP: { numericCode: '072', minorUnit: 2, currencyName: 'Botswana Pula' },
  BYN: { numericCode: '933', minorUnit: 2, currencyName: 'Belarusian Ruble' },
  BZD: { numericCode: '084', minorUnit: 2, currencyName: 'Belize Dollar' },
  CAD: { numericCode: '124', minorUnit: 2, currencyName: 'Canadian Dollar' },
  CDF: { numericCode: '976', minorUnit: 2, currencyName: 'Congolese Franc' },
  CHE: { numericCode: '947', minorUnit: 2, currencyName: 'WIR Euro' },
  CHF: { numericCode: '756', minorUnit: 2, currencyName: 'Swiss Franc' },
  CHW: { numericCode: '948', minorUnit: 2, currencyName: 'WIR Franc' },
  CLP: { numericCode: '152', minorUnit: 0, currencyName: 'Chilean Peso' },
  CNY: { numericCode: '156', minorUnit: 2, currencyName: 'Renminbi' },
  COP: { numericCode: '170', minorUnit: 2, currencyName: 'Colombian Peso' },
  CRC: { numericCode: '188', minorUnit: 2, currencyName: 'Costa Rican Colon' },
  CUC: { numericCode: '931', minorUnit: 2, currencyName: 'Cuban Convertible Peso' },
  CUP: { numericCode: '192', minorUnit: 2, currencyName: 'Cuban Peso' },
  CVE: { numericCode: '132', minorUnit: 2, currencyName: 'Cape Verdean Escudo' },
  CZK: { numericCode: '203', minorUnit: 2, currencyName: 'Czech Koruna' },
  DJF: { numericCode: '262', minorUnit: 0, currencyName: 'Djiboutian Franc' },
  DKK: { numericCode: '208', minorUnit: 2, currencyName: 'Danish Krone' },
  DOP: { numericCode: '214', minorUnit: 2, currencyName: 'Dominican Peso' },
  DZD: { numericCode: '012', minorUnit: 2, currencyName: 'Algerian Dinar' },
  EGP: { numericCode: '818', minorUnit: 2, currencyName: 'Egyptian Pound' },
  ERN: { numericCode: '232', minorUnit: 2, currencyName: 'Eritrean Nakfa' },
  ETB: { numericCode: '230', minorUnit: 2, currencyName: 'Ethiopian Birr' },
  EUR: { numericCode: '978', minorUnit: 2, currencyName: 'Euro' },
  FJD: { numericCode: '242', minorUnit: 2, currencyName: 'Fiji Dollar' },
  FKP: { numericCode: '238', minorUnit: 2, currencyName: 'Falkland Islands Pound' },
  GBP: { numericCode: '826', minorUnit: 2, currencyName: 'Pound Sterling' },
  GEL: { numericCode: '981', minorUnit: 2, currencyName: 'Georgian Lari' },
  GHS: { numericCode: '936', minorUnit: 2, currencyName: 'Ghanaian Cedi' },
  GIP: { numericCode: '292', minorUnit: 2, currencyName: 'Gibraltar Pound' },
  GMD: { numericCode: '270', minorUnit: 2, currencyName: 'Gambian Dalasi' },
  GNF: { numericCode: '324', minorUnit: 0, currencyName: 'Guinean Franc' },
  GTQ: { numericCode: '320', minorUnit: 2, currencyName: 'Guatemalan Quetzal' },
  GYD: { numericCode: '328', minorUnit: 2, currencyName: 'Guyanese Dollar' },
  HKD: { numericCode: '344', minorUnit: 2, currencyName: 'Hong Kong Dollar' },
  HNL: { numericCode: '340', minorUnit: 2, currencyName: 'Honduran Lempira' },
  HRK: { numericCode: '191', minorUnit: 2, currencyName: 'Croatian Kuna' },
  HTG: { numericCode: '332', minorUnit: 2, currencyName: 'Haitian Gourde' },
  HUF: { numericCode: '348', minorUnit: 2, currencyName: 'Hungarian Forint' },
  IDR: { numericCode: '360', minorUnit: 2, currencyName: 'Indonesian Rupiah' },
  ILS: { numericCode: '376', minorUnit: 2, currencyName: 'Israeli New Shekel' },
  INR: { numericCode: '356', minorUnit: 2, currencyName: 'Indian Rupee' },
  IQD: { numericCode: '368', minorUnit: 3, currencyName: 'Iraqi Dinar' },
  IRR: { numericCode: '364', minorUnit: 2, currencyName: 'Iranian Rial' },
  ISK: { numericCode: '352', minorUnit: 0, currencyName: 'Icelandic króna' },
  JMD: { numericCode: '388', minorUnit: 2, currencyName: 'Jamaican Dollar' },
  JOD: { numericCode: '400', minorUnit: 3, currencyName: 'Jordanian Dinar' },
  JPY: { numericCode: '392', minorUnit: 0, currencyName: 'Japanese Yen' },
  KES: { numericCode: '404', minorUnit: 2, currencyName: 'Kenyan Shilling' },
  KGS: { numericCode: '417', minorUnit: 2, currencyName: 'Kyrgyzstani Som' },
  KHR: { numericCode: '116', minorUnit: 2, currencyName: 'Cambodian Riel' },
  KMF: { numericCode: '174', minorUnit: 0, currencyName: 'Comoro Franc' },
  KPW: { numericCode: '408', minorUnit: 2, currencyName: 'North Korean Won' },
  KRW: { numericCode: '410', minorUnit: 0, currencyName: 'South Korean Won' },
  KWD: { numericCode: '414', minorUnit: 3, currencyName: 'Kuwaiti Dinar' },
  KYD: { numericCode: '136', minorUnit: 2, currencyName: 'Cayman Islands Dollar' },
  KZT: { numericCode: '398', minorUnit: 2, currencyName: 'Kazakhstani Tenge' },
  LAK: { numericCode: '418', minorUnit: 2, currencyName: 'Lao Kip' },
  LBP: { numericCode: '422', minorUnit: 2, currencyName: 'Lebanese Pound' },
  LKR: { numericCode: '144', minorUnit: 2, currencyName: 'Sri Lankan Rupee' },
  LRD: { numericCode: '430', minorUnit: 2, currencyName: 'Liberian Dollar' },
  LSL: { numericCode: '426', minorUnit: 2, currencyName: 'Lesotho Loti' },
  LYD: { numericCode: '434', minorUnit: 3, currencyName: 'Libyan Dinar' },
  MAD: { numericCode: '504', minorUnit: 2, currencyName: 'Moroccan Dirham' },
  MDL: { numericCode: '498', minorUnit: 2, currencyName: 'Moldovan Leu' },
  MGA: { numericCode: '969', minorUnit: 2, currencyName: 'Malagasy Ariary' },
  MKD: { numericCode: '807', minorUnit: 2, currencyName: 'Macedonian Denar' },
  MMK: { numericCode: '104', minorUnit: 2, currencyName: 'Myanmar Kyat' },
  MNT: { numericCode: '496', minorUnit: 2, currencyName: 'Mongolian Tögrög (Tugrik)' },
  MOP: { numericCode: '446', minorUnit: 2, currencyName: 'Macanese Pataca' },
  MRU: { numericCode: '929', minorUnit: 2, currencyName: 'Mauritanian Ouguiya' },
  MUR: { numericCode: '480', minorUnit: 2, currencyName: 'Mauritian Rupee' },
  MVR: { numericCode: '462', minorUnit: 2, currencyName: 'Maldivian Rufiyaa' },
  MWK: { numericCode: '454', minorUnit: 2, currencyName: 'Malawian Kwacha' },
  MXN: { numericCode: '484', minorUnit: 2, currencyName: 'Mexican Peso' },
  MYR: { numericCode: '458', minorUnit: 2, currencyName: 'Malaysian Ringgit' },
  MZN: { numericCode: '943', minorUnit: 2, currencyName: 'Mozambican Metical' },
  NAD: { numericCode: '516', minorUnit: 2, currencyName: 'Namibian Dollar' },
  NGN: { numericCode: '566', minorUnit: 2, currencyName: 'Nigerian Naira' },
  NIO: { numericCode: '558', minorUnit: 2, currencyName: 'Cordoba Oro' },
  NOK: { numericCode: '578', minorUnit: 2, currencyName: 'Norwegian Krone' },
  NPR: { numericCode: '524', minorUnit: 2, currencyName: 'Nepalese Rupee' },
  NZD: { numericCode: '554', minorUnit: 2, currencyName: 'New Zealand Dollar' },
  OMR: { numericCode: '512', minorUnit: 3, currencyName: 'Omani Rial' },
  PAB: { numericCode: '590', minorUnit: 2, currencyName: 'Panamanian Balboa' },
  PEN: { numericCode: '604', minorUnit: 2, currencyName: 'Peruvian Sol' },
  PGK: { numericCode: '598', minorUnit: 2, currencyName: 'Papua New Guinean Kina' },
  PHP: { numericCode: '608', minorUnit: 2, currencyName: 'Philippine Peso' },
  PKR: { numericCode: '586', minorUnit: 2, currencyName: 'Pakistan Rupee' },
  PLN: { numericCode: '985', minorUnit: 2, currencyName: 'Polish Złoty' },
  PYG: { numericCode: '600', minorUnit: 0, currencyName: 'Paraguayan Guaraní' },
  QAR: { numericCode: '634', minorUnit: 2, currencyName: 'Qatari Rial' },
  RON: { numericCode: '946', minorUnit: 2, currencyName: 'Romanian Leu' },
  RSD: { numericCode: '941', minorUnit: 2, currencyName: 'Serbian Dinar' },
  RUB: { numericCode: '643', minorUnit: 2, currencyName: 'Russian Ruble' },
  RWF: { numericCode: '646', minorUnit: 0, currencyName: 'Rwandan Franc' },
  SAR: { numericCode: '682', minorUnit: 2, currencyName: 'Saudi Riyal' },
  SBD: { numericCode: '090', minorUnit: 2, currencyName: 'Solomon Islands Dollar' },
  SCR: { numericCode: '690', minorUnit: 2, currencyName: 'Seychelles Rupee' },
  SDG: { numericCode: '938', minorUnit: 2, currencyName: 'Sudanese Pound' },
  SEK: { numericCode: '752', minorUnit: 2, currencyName: 'Swedish Krona' },
  SGD: { numericCode: '702', minorUnit: 2, currencyName: 'Singapore Dollar' },
  SHP: { numericCode: '654', minorUnit: 2, currencyName: 'Saint Helena Pound' },
  SLE: { numericCode: '925', minorUnit: 2, currencyName: 'Sierra Leonean Leone' },
  SLL: { numericCode: '694', minorUnit: 2, currencyName: 'Sierra Leonean Leone' },
  SOS: { numericCode: '706', minorUnit: 2, currencyName: 'Somali Shilling' },
  SRD: { numericCode: '968', minorUnit: 2, currencyName: 'Surinamese Dollar' },
  SSP: { numericCode: '728', minorUnit: 2, currencyName: 'South Sudanese Pound' },
  STN: { numericCode: '930', minorUnit: 2, currencyName: 'São Tomé and Príncipe Dobra' },
  SVC: { numericCode: '222', minorUnit: 2, currencyName: 'Salvadoran Colón' },
  SYP: { numericCode: '760', minorUnit: 2, currencyName: 'Syrian Pound' },
  SZL: { numericCode: '748', minorUnit: 2, currencyName: 'Swazi Lilangeni' },
  THB: { numericCode: '764', minorUnit: 2, currencyName: 'Thai Baht' },
  TJS: { numericCode: '972', minorUnit: 2, currencyName: 'Tajikistani Somoni' },
  TMT: { numericCode: '934', minorUnit: 2, currencyName: 'Turkmenistan Manat' },
  TND: { numericCode: '788', minorUnit: 3, currencyName: 'Tunisian Dinar' },
  TOP: { numericCode: '776', minorUnit: 2, currencyName: 'Tongan Paʻanga' },
  TRY: { numericCode: '949', minorUnit: 2, currencyName: 'Turkish Lira' },
  TTD: {
    numericCode: '780',
    minorUnit: 2,
    currencyName: 'Trinidad and Tobago Dollar',
  },
  TWD: { numericCode: '901', minorUnit: 2, currencyName: 'New Taiwan Dollar' },
  TZS: { numericCode: '834', minorUnit: 2, currencyName: 'Tanzanian Shilling' },
  UAH: { numericCode: '980', minorUnit: 2, currencyName: 'Ukrainian Hryvnia' },
  UGX: { numericCode: '800', minorUnit: 0, currencyName: 'Uganda Shilling' },
  USD: { numericCode: '840', minorUnit: 2, currencyName: 'US Dollar' },
  UYU: { numericCode: '858', minorUnit: 2, currencyName: 'Uruguayan Peso' },
  UYW: { numericCode: '927', minorUnit: 4, currencyName: 'Unidad Previsional' },
  UZS: { numericCode: '860', minorUnit: 2, currencyName: 'Uzbekistan Sum' },
  VED: { numericCode: '926', minorUnit: 2, currencyName: 'Bolívar Digital' },
  VES: { numericCode: '928', minorUnit: 2, currencyName: 'Bolívar Soberano' },
  VND: { numericCode: '704', minorUnit: 0, currencyName: 'Dong' },
  VUV: { numericCode: '548', minorUnit: 0, currencyName: 'Vanuatu Vatu' },
  WST: { numericCode: '882', minorUnit: 2, currencyName: 'Samoan Tala' },
  YER: { numericCode: '886', minorUnit: 2, currencyName: 'Yemeni Rial' },
  ZAR: { numericCode: '710', minorUnit: 2, currencyName: 'South African Rand' },
  ZMW: { numericCode: '967', minorUnit: 2, currencyName: 'Zambian Kwacha' },
  ZWL: { numericCode: '932', minorUnit: 2, currencyName: 'Zimbabwean Dollar' },
} as const;

// NOTE: choosing Alpha-2 codes as key to avoid collisions is they even exist
// last updated 1 April 2022 => https://www.iban.com/country-codes
export const COUNTRIES_BY_ALPHA_TWO_CODE = {
  AU: {
    name: 'Australia',
    alphaThreeCode: 'AUS',
    numericCode: '036',
    primaryCurrency: {
      code: 'AUD',
      numericCode: '036',
    },
  },
  CA: {
    name: 'Canada',
    alphaThreeCode: 'CAD',
    numericCode: '124',
    primaryCurrency: {
      code: 'CAD',
      numericCode: '124',
    },
  },
  GB: {
    name: 'United Kingdom of Great Britain',
    alphaThreeCode: 'GBR',
    numericCode: '826',
    primaryCurrency: {
      code: 'GBP',
      numericCode: '826',
    },
  },
  IQ: {
    name: 'Iraq',
    alphaThreeCode: 'IRQ',
    numericCode: '368',
    primaryCurrency: {
      code: 'IQD',
      numericCode: '368',
    },
  },
  JP: {
    name: 'Japan',
    alphaThreeCode: 'JPN',
    numericCode: '392',
    primaryCurrency: {
      code: 'JPY',
      numericCode: '392',
    },
  },
  NZ: {
    name: 'New Zealand',
    alphaThreeCode: 'NZL',
    numericCode: '554',
    primaryCurrency: {
      code: 'NZD',
      numericCode: '554',
    },
  },
  US: {
    name: 'United States of America',
    alphaThreeCode: 'USA',
    numericCode: '840',
    primaryCurrency: {
      code: 'USD',
      numericCode: '840',
    },
  },
} as const;
